import React, { useEffect } from 'react';
import { initPixel } from './lib/pixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Modules } from './components/Modules';
import { TriadAndBonuses } from './components/TriadAndBonuses';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark text-gray-100 font-sans selection:bg-brand-volt selection:text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Modules data-id="element-3" />
      <TriadAndBonuses data-id="element-4" />
      <Offer data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}